<mojo-lister entityName="Landlord"
             [ownerEntityKey]="entityKey$ | async"
             (onRowSelect)="handleRowSelect($event)"
             [getRowHref]="getRowHref">
</mojo-lister>
